import { PlatformDevice } from '@/client/services/platform/constants'
import composeRichText from '@/client/services/richText/composeRichText'
import { getUnapprovedPageUrl } from '@/client/services/url'
import { hasUserRole } from '@/client/services/user'

import { makeBannerDataLoader } from './helpers'

export default makeBannerDataLoader({
  name: 'pending-approval',
  load(context) {
    if (!hasUserRole(context.user, 'user:unapproved')) {
      return null
    }
    if (context.user.platformDevice !== PlatformDevice.DESKTOP) {
      return {
        sticky: true,
        content: composeRichText(ctx =>
          ctx.paragraph(
            'Your Schoolhouse account is ',
            ctx.linkInternal(getUnapprovedPageUrl(), 'under review'),
            '.'
          )
        ),
      }
    }

    return {
      sticky: true,
      content: composeRichText(ctx =>
        ctx.paragraph(
          "Your Schoolhouse account is under review. You can't join or register for sessions just yet! See ",
          ctx.linkInternal(getUnapprovedPageUrl(), 'this page'),
          ' for details.'
        )
      ),
    }
  },
})
